@let alertDev = store.alertDev();

<tui-root
  [attr.tuiTheme]="'light'"
  [attr.nav-collapse]="isNavCollapse"
  [attr.rdd-mode]="cockpitDisplayStateService._displayState === 'rdd'"
  [attr.rdd-filter-visible]="cockpitDisplayStateService._displayFilter"
>
  @if (isCockpitRoute) {
    <section class="cockpit-display-controls" aria-label="Affichage du cockpit">
      @if (cockpitDisplayStateService._displayState === 'rdd') {
        <nav class="cockpit-area-navigation" aria-label="Navigation du cockpit en mode RDD">
          <a class="btn--group btn--previous" routerLink="/cockpit/vn" routerLinkActive="btn--group--active">VN</a>
          <a class="btn--group btn--center" routerLink="/cockpit/vo" routerLinkActive="btn--group--active">VO</a>
          <a class="btn--group btn--center" routerLink="/cockpit/atelier" routerLinkActive="btn--group--active">Atelier</a>
          <a class="btn--group btn--next" routerLink="/cockpit/mpr" routerLinkActive="btn--group--active">MPR</a>
        </nav>
        <button class="btn btn--sm btn--white" type="button" (click)="toggleRddFilters()">
          {{ cockpitDisplayStateService._displayFilter ? 'Masquer Filtres' : 'Afficher Filtres' }}
        </button>
      }
      <button class="btn btn--sm btn--primary" type="button" (click)="toggleRddMode()">
        {{ cockpitDisplayStateService._displayState === 'rdd' ? 'Mode Normal' : 'Mode RDD' }}
      </button>
    </section>
  }
  @if (idle.toggleIdleModal()) {
    <article class="idle-modal">
      <section id="bg"></section>
      <section class="modal">
        <h4 class="text--xl text--bold primary-500">Attention</h4>
        <p class="text--sm primary-500">Votre session va expirer dans {{ idle.remainingTime() }} secondes.</p>
        <button class="btn btn--sm btn--primary" (click)="resetIdleTimer()">Rester connecté</button>
      </section>
    </article>
  }
  @if (store.isAuthentified() && cockpitDisplayStateService._displayState != 'rdd') {
    <app-navbar />
    <app-breadcrumb />
  }
  <app-mini-headband
    [toggle]="modal.miniHeadband.toggle()"
    [content]="modal.miniHeadband.content()"
    [btnPrimaryText]="modal.miniHeadband.btnPrimaryText()"
    [btnSecondaryText]="modal.miniHeadband.btnSecondaryText()"
    (callbackBtn)="modal.miniHeadband.callbackBtn()($event)"
  ></app-mini-headband>
  <app-mini-alert
    [toggle]="modal.miniAlert.toggle()"
    [message]="modal.miniAlert.message()"
    (onToggleChange)="modal.miniAlert.callback()()"
  ></app-mini-alert>
  <router-outlet />
  <app-spinner />
  <app-admin-guard />
  @for (alert of alertDev; track $index) {
    <app-headband
      [display]="true"
      [title]="alert.title"
      [content]="alert.content"
      [type]="alert.type"
      [primaryBtnLabel]="`j'ai compris`"
      (bntCallback)="store.onAlertDevCLick($event, alert.id)"
      (closeCrossCallback)="store.onAlertDevCLick(false, alert.id)"
    />
  }
  <app-alert
    [title]="modal.alert.title()"
    [msg]="modal.alert.msg()"
    [toggle]="modal.alert.toggle()"
    [type]="modal.alert.type()"
    (callback)="modal.alert.callback()()"
  ></app-alert>
  <app-confirm
    [title]="modal.confirm.title()"
    [msg]="modal.confirm.msg()"
    [toggle]="modal.confirm.toggle()"
    [type]="modal.confirm.type()"
    (callback)="modal.confirm.callback()($event)"
    [btnCancelText]="modal.confirm.cancelBtnText()"
    [btnConfirmText]="modal.confirm.confirmBtnText()"
  ></app-confirm>
  <app-comment-modal-bilat [toggle]="modal.bilatComment.toggle()" [bilatId]="modal.bilatComment.bilatId()"></app-comment-modal-bilat>
</tui-root>
